const comParticle = (() => {
  const jsComParticleJsWrap = (document.getElementById("jsComParticleJsWrap") != null);
  if (jsComParticleJsWrap) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;

    let particleSize
    let particleSizeMin

    if (sW >= 768) {
      particleSize = Math.round(sW / 20)
      particleSizeMin = particleSize - 10
    } else {
      particleSize = Math.round(sW / 10)
      particleSizeMin = particleSize - 10
    }
    // console.log(particleSize);


    let retina = window.devicePixelRatio;
    let valueArea;

    if (sW >= 768) {
      if (retina < 2) {
        valueArea = 700
      } else if (retina >= 2) {
        valueArea = 1400
      }
    } else {
      valueArea = 240
    }

    // let id1 = 'jsTopParticle1'
    // let id2 = 'jsTopParticle2'
    // let id3 = 'jsTopParticle3'

    // let imgPath1 = './assets/build/img/top/particles_1.png'
    // let imgPath2 = './assets/build/img/top/particles_2.png'
    // let imgPath3 = './assets/build/img/top/particles_3.png'

    
    for (let i = 1; i <= 3; i++) {
      // console.log(`jsTopParticle${i}`);
      // console.log(`./assets/build/img/top/particles_${i}.png`);

      particlesJS(`jsComParticle${i}`, {
        "particles": {
          //シェイプの設定「線を繋ぐ丸や三角形などのこと」
          "number": {
            "value": 10,           //シェイプの数
            "density": {
              "enable": true,      //シェイプの密集度の変更
              "value_area": valueArea    //密集度
            }
          },
          "color": {
            "value": "#ffffff"     //シェイプの色
          },
          "shape": {
            "type": "image",      //形『circle:丸、edge:四角、triangle:三角、polygon:多角形、star:星型、image:画像』
            "stroke": {
              "width": 0,          //外線の太さ
              "color": "#000000"   //外線の色
            },
            // polygon選択時
            "polygon": {
              "nb_sides": 5       //何角形か
            },
            "image": {
              "src": `../assets/build/img/top/particles_${i}.png`,
              "width": 512,
              "height": 512
            }
          },
          "opacity": {
            "value": 1,          //透明度
            "random": false,       //透明度ランダム
            "anim": {
              "enable": false,     //透明度のアニメーションさせるかどうか
              "speed": 2,          //アニメーションのスピード
              "opacity_min": 0.1,  //透明度の最小値
              "sync": false        //シェイプを同時にアニメーションさせるかどうか
            }
          },
          "size": {
            "value": particleSize,            //シェイプの大きさ 120
            "random": true,        //大きさランダム
            "anim": {
              "enable": false,     //大きさアニメーション
              "speed": 10,         //スピード
              "size_min": particleSizeMin,     //最小値 100
              "sync": true        //同時にアニメーションするかどうか
            }
          },
          // 線の設定
          "line_linked": {
            "enable": false,        //線を表示するかどうか
            "distance": 150,       //点と点の間隔の距離
            "color": "#ffffff",    //線の色
            "opacity": 0.4,        //透明度
            "width": 1             //太さ
          },
          // 動きの設定
          "move": {
            "enable": true,        //シェイプの動くスピード
            "speed": 1.0,            //個々の動きを止めるかどうか
            "direction": "top",   ////エリア全体の動き(none、top、top-right、right、bottom-right、bottom、bottom-left、left、top-leftより選択)
            "random": true,
            "straight": false,     //マウスオーバーでのみ動く
            "out_mode": "out",     //エリア外に出たシェイプの動き(out、bounceより選択)
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            //マウスオーバー時
            "onhover": {
              "enable": false,        //マウスオーバーの許可
              "mode": "repulse"      //オーバー時の動き『grab(集まる)、repulse(逃げる)、bubble(シェイプが大きくなる)』
            },
            "onclick": {
              "enable": false,        //クッリクの許可
              "mode": "repulse"      //クリック時の動き『grab、repulse、bubble、push(増殖)、remove(死滅)』
            },
          },
          //カーソルとシェイプの間の線
          "modes": {
            "grab": {
              "distance": 400,       //カーソルからの距離
              "line_linked": {
                "opacity": 1
              }
            },
            // 膨張
            "bubble": {
              "distance": 400,       //カーソルからの距離
              "size": 40,            //膨張する大きさ
              "duration": 2,         //継続時間(クリック時のみ)
              "opacity": 8,
              "speed": 3            //膨張スピード
            },
            // カーソルから逃げる
            "repulse": {
              "distance": 200,     //距離
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4    //増える数
            },
            "remove": {
              "particles_nb": 2    //消える数
            }
          }
        },
        "retina_detect": false,      //Retina Displayを対応
        "resize": true              //canvasのサイズにあらせて変更する
      });

    }


    gsap.to('#jsComParticleJsWrap', {
      scrollTrigger: {
        trigger: 'body',
        start: 'top -10%',
        endTrigger: 'body',
        end: 'bottom top',
        toggleClass: { targets: '#jsComParticleJsWrap', className: "opacity" },
        // markers: true,
      }
    });

    gsap.to('#jsComParticleJsWrap', {
      scrollTrigger: {
        trigger: '#jsComParticleJsWrapNoneTrigger',
        start: 'top bottom',
        endTrigger: 'body',
        end: 'bottom top',
        toggleClass: { targets: '#jsComParticleJsWrap', className: "none" },
        // markers: true,
      }
    });






  }
})()
export default comParticle;